import en from './localizations/en.json';
import it from './localizations/it.json';

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const languages: { it: any; en: any } = {
  en,
  it,
};
